import { useEffect } from "react";
import { Form } from "antd";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { ERROR_MSGS, BTN_TXT, YESORNO } from "../../../../constants/constants";
import FormFooter from "../../../../components/CustomForms/FormFooter";
import ErrorAlert from "../../../../components/ErrorAlert/ErrorAlert";
import { useSelector, useDispatch } from "react-redux";
import { newassignRM, getAssginRM } from "../../../../redux/slices/rmSlice";

const AssignRmForm = ({ onClose }) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { assignRmLoading, error, dropdownData } = useSelector((state) => state.rm);

    useEffect(() => {
        dispatch(getAssginRM());
    }, [dispatch]);

    const handleAssignRm = () => {
        dispatch(newassignRM())
    }

    return (
        <Form layout="vertical" form={form} initialValues={{ sameRmToAll: false }} onFinish={handleAssignRm}>

            <CustomSelect
                name="rm"
                label="Select RM"
                placeholder="Select RM"
                isRequired={true}
                rules={[{ required: true, message: ERROR_MSGS.SEL_RM_ERR_MSG }]}
                options={dropdownData?.rmList?.map((user) => ({
                    value: user.userId,
                    label: user.userName,
                }))}
            />

            <CustomSelect
                name="orgName"
                label="Organization"
                placeholder="Select Organization"
                isRequired={true}
                rules={[{ required: true, message: ERROR_MSGS.SEL_ORG_ERR_MSG }]}
                options={dropdownData?.orgDetails?.map((org) => ({
                    value: org.orgId,
                    label: org.orgName,
                }))}
            />

            <CustomSelect
                name="sameRmToAll"
                label="Assign same RM to all Users?"
                placeholder="Select Yes/No"
                isRequired={true}
                options={YESORNO?.map((item) => ({
                    value: item.value,
                    label: item.label,
                }))}
            />

            {/* <CustomSelect
                name="roles"
                label="Roles"
                placeholder="Select Role(s)"
                isRequired={true}
                mode="multiple"
                rules={[{ required: true, message: ERROR_MSGS.SEL_ROLE_ERR_MSG }]}
                options={roleList?.map((role) => ({
                    value: role.roleId,
                    label: capitalizeWords(role.roleName),
                }))}
                tagRender={({ value, closable, onClose }) => {
                    const role = roleList?.find((r) => r.roleId === value);
                    return <RoleTag roles={[role]} closable={closable} onClose={onClose} />;
                }}
            /> */}

            {error && (
                <ErrorAlert error={error} />
            )}

            <FormFooter
                onCancelClick={() => {
                    onClose();
                    form.resetFields();
                }}
                submitLoading={assignRmLoading}
                btnName={BTN_TXT.ASSIGN}
            />
        </Form>
    )
}

export default AssignRmForm